import { render } from "./BuilderLightboxImages.vue?vue&type=template&id=03ccdb96&scoped=true&ts=true&lang=pug"
import script from "./BuilderLightboxImages.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuilderLightboxImages.vue?vue&type=script&setup=true&lang=ts"

import "./BuilderLightboxImages.vue?vue&type=style&index=0&id=03ccdb96&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03ccdb96"]])

export default __exports__